export enum yesNoValues {
  YES = 'yes',
  NO = 'no'
}
